import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TdTextComponent } from "./td-text.component";
import { LoaderModule } from "../../loader/loader.module";

@NgModule({
 imports: [
     CommonModule,
     LoaderModule,
 ],
 exports: [
     TdTextComponent,
 ],
 declarations: [
     TdTextComponent,
 ],
 providers: [],
})
export class TdTextModule { }
